
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
  }
})
export default class CollectionCard extends Vue {
  @Prop({ required: true })readonly numMaxOfArtefatos: number
  @Prop({ required: true })readonly numOfWords: number
  @Prop({ required: true })readonly id: number
  @Prop({ required: true })readonly searchTerms: string
  @Prop({ required: true })readonly isMine: boolean
  data () {
    return {
    }
  }

  async removeUserFromCollection () {
    this.isLoading = true
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/removeUserFromCollection/${this.id}`))
      this.isLoading = false
      this.$emit('removedFromMyCollections', { id: this.id })
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not remove from my collections.',
        canCancel: false
      })
    }
  }

  async addUserToCollection () {
    this.isLoading = true
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/addUserToCollection/${this.id}`))
      this.isLoading = false
      this.$emit('addedUserToCollection', { id: this.id })
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not add to my collections.',
        canCancel: false
      })
    }
  }

  playCollection () {
    // this.$router.push(`/home/player/${this.id}`)
    window.location.href = `/home/collection/${this.id}`
  }
}
